@if (loadingService.isLoading()) {
<div class="overlay-container" @fadeInOut>
  <div class="spinner-wrapper">
    <div class="spinner"></div>
    @if (loadingService.message()) {
      <div class="message">{{ loadingService.message() }}</div>
    }
  </div>
</div>
}
